/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PamInstallmentsResponseDto } from '../models/pam-installments-response-dto';


/**
 * the PamQueryListInstallments API
 */
@Injectable({
  providedIn: 'root',
})
export class PamQueryListInstallmentsService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation installmentList
   */
  static readonly InstallmentListPath = '/installments';

  /**
   * Get list of the installments
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `installmentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  installmentList$Response(params: {
    page: number;
    size: number;
    filter?: Array<string>;
    sort?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PamInstallmentsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PamQueryListInstallmentsService.InstallmentListPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('filter', params.filter, {});
      rb.query('sort', params.sort, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PamInstallmentsResponseDto>;
      })
    );
  }

  /**
   * Get list of the installments
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `installmentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  installmentList(params: {
    page: number;
    size: number;
    filter?: Array<string>;
    sort?: Array<string>;
  },
  context?: HttpContext

): Observable<PamInstallmentsResponseDto> {

    return this.installmentList$Response(params,context).pipe(
      map((r: StrictHttpResponse<PamInstallmentsResponseDto>) => r.body as PamInstallmentsResponseDto)
    );
  }

}
